import React, { useEffect, useState } from 'react'
import { getEmployeesWithPage } from "../../services/serviceEmployee";
import EmployeeCreate from "./EmployeeCreate";
import EmployeeActions from "./EmployeeActions";
import { Button, Card, Table } from "antd";
import userDateFormatter from "../../services/formatters/userDateFormatter";

const Employee = () => {
    const [sortedList, setSortedList] = useState([]);
    const [newModal, setNewModal] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getEmployees(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getEmployees = (page, pageSize) => {
        getEmployeesWithPage(page - 1, pageSize)
            .then(({ data }) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
            })
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const handlers = {
        updater() {
            getEmployees(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    employeeName: item.name,
                    employeeSurname: item.surname,
                    employeeCode: item.code,
                    employeeDepartment: item.department.code,
                    internalPhoneCode: item.internalPhoneCode,
                    title: item.title,
                    phoneNumber: item.phoneNumber,
                    birthDate: item.birthdate
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    };

    const columns = [
        {
            title: 'Adı',
            dataIndex: 'employeeName',
            key: 'employeeName',
            render: (t, r) => `${t} ${r.employeeSurname}`
        },
        {
            title: 'Departmanı',
            dataIndex: 'employeeDepartment',
            key: 'employeeDepartment'
        },
        {
            title: 'Çalışan Kodu',
            dataIndex: 'employeeCode',
            key: 'employeeCode'
        },
        {
            title: 'Ünvan',
            dataIndex: 'title',
            key: 'title'
        },
        {
            title: 'Cep Telefonu',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber'
        },
        {
            title: 'Dahili',
            dataIndex: 'internalPhoneCode',
            key: 'internalPhoneCode'
        },
        {
            title: 'Doğum Tarihi',
            dataIndex: 'birthDate',
            key: 'birthDate',
            render: (text) => userDateFormatter(text)
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <EmployeeActions record={record} updater={handlers.updater} />
        }
    ];

    return (
        <React.Fragment>
            <Card title={'Çalışan Listesi'} extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'}>Yeni Ekle</Button>}>
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>
            {newModal ? <EmployeeCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater} /> : null}

        </React.Fragment>
    )
}
export default Employee